/* @jsx mdx */
import React from 'react'
import { mdx } from '@mdx-js/react'

import { Cite, Slide, Heading, Text, Box, FlexBox, Image, Appear, Markdown } from "spectacle";
import {LeftContentRightContent, LeftCodeRightContent, LeftCodeRightMarkdown, LeftContentRightMarkdown, LeftCodeRightCode} from "components/layout";
import configureStore from "./examples/configureStore";
import configureStore2 from "./examples/configureStore2";
import immer from "./examples/immer";
import createReducer from "./examples/createReducer";
import createAction from "./examples/createAction";
import createSlice from "./examples/createSlice";
import createSlice2 from "./examples/createSlice2";
import createSelector from "./examples/createSelector";
import createAsyncThunk from "./examples/createAsyncThunk";
import createEntityAdapter from "./examples/createEntityAdapter";
import rtkQueryExample from "./examples/rtkQuery";
import rtkQueryExample2 from "./examples/rtkQuery2";
import tsSetup from "./examples/tsSetup";
import tsUsage from "./examples/tsUsage";

function MDXContentWrapperSlide0(props) {
  /* @jsxRuntime classic */
/* @jsx mdx */

















const makeShortcode = name => function MDXDefaultShortcode(props) {
      console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope")
      return <div {...props}/>
    };
const TitleDummy = makeShortcode("TitleDummy");
const layoutProps = {
  
};
const MDXLayout = "wrapper"
function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    {
      /* prettier-ignore-start */
    }
    {
      /* prettier-ignore-end */
    }
    <TitleDummy mdxType="TitleDummy" />
    <h1>{`Redux Toolkit`}</h1>
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;
  return (<MDXContent {...props} />);
};
MDXContentWrapperSlide0.isMDXComponent = true;

function MDXContentWrapperSlide1(props) {
  /* @jsxRuntime classic */
/* @jsx mdx */


















const layoutProps = {
  
};
const MDXLayout = "wrapper"
function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    <h4>{`Redux Toolkit`}</h4>
    <ul>
      <li parentName="ul">{`Created a new official package called `}<strong parentName="li"><a parentName="strong" {...{
            "href": "https://redux-toolkit.js.org/"
          }}>{`Redux Toolkit`}</a></strong>{`, inspired by
`}<inlineCode parentName="li">{`create-react-app`}</inlineCode>{` and `}<inlineCode parentName="li">{`apollo-boost`}</inlineCode>{`.`}</li>
      <li parentName="ul">{`Goals:`}
        <ul parentName="li">
          <li parentName="ul">{`Simplify common Redux use cases`}</li>
          <li parentName="ul">{`Provide good opinionated defaults out of the box`}</li>
          <li parentName="ul">{`Minimize the amount of code you have to write by hand`}</li>
          <li parentName="ul">{`Doesn't "hide" that you're using Redux, just makes it easier`}</li>
          <li parentName="ul">{`Opt-in - can add incrementally to an existing app, or use day 1 on a new project`}</li>
          <li parentName="ul">{`Provide a great developer experience for TypeScript users`}</li>
        </ul>
      </li>
      <li parentName="ul">{`Originally named "Redux Starter Kit", but renamed after 1.0 release`}
        <ul parentName="li">
          <li parentName="ul">{`Confusion over "starter kit" naming: boilerplate? only good for beginners?`}</li>
          <li parentName="ul">{`Renamed to "Redux Toolkit" (package: `}<inlineCode parentName="li">{`@reduxjs/toolkit`}</inlineCode>{` ) for 1.0.4 release`}</li>
        </ul>
      </li>
      <li parentName="ul">{`Written in TypeScript, designed to simplify TS usage patterns`}</li>
      <li parentName="ul">{`Most recent TS and API dev work thanks to co-maintainer Lenz Weber (`}<inlineCode parentName="li">{`@phryneas`}</inlineCode>{`)`}</li>
    </ul>
    <h5>{`Useful for `}<i>{`all`}</i>{` Redux users, both new and experienced!`}</h5>
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;
  return (<MDXContent {...props} />);
};
MDXContentWrapperSlide1.isMDXComponent = true;

function MDXContentWrapperSlide2(props) {
  /* @jsxRuntime classic */
/* @jsx mdx */


















const layoutProps = {
  
};
const MDXLayout = "wrapper"
function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    <h4>{`Redux Toolkit: `}<inlineCode parentName="h4">{`configureStore()`}</inlineCode></h4>
    <LeftCodeRightMarkdown leftSource={configureStore} leftStyle={{}} mdxType="LeftCodeRightMarkdown">{`
- A small wrapper around the Redux \`createStore\` function:
  - Automatically sets up the Redux DevTools extension by default
  - Automatically adds \`redux-thunk\` by default, plus middleware to check for accidental mutations and non-serializable values
  - Accepts either a root reducer function, or an object of slice reducers and will automatically call \`combineReducers\` for you
  - Accepts middlewares and store enhancers as arrays, and composes them properly
`}</LeftCodeRightMarkdown>
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;
  return (<MDXContent {...props} />);
};
MDXContentWrapperSlide2.isMDXComponent = true;

function MDXContentWrapperSlide3(props) {
  /* @jsxRuntime classic */
/* @jsx mdx */


















const layoutProps = {
  
};
const MDXLayout = "wrapper"
function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    <h4>{`Redux Toolkit: `}<inlineCode parentName="h4">{`configureStore()`}</inlineCode></h4>
    <LeftCodeRightMarkdown leftSource={configureStore2} leftStyle={{
      minWidth: 700
    }} mdxType="LeftCodeRightMarkdown">{`
- Options are passed as a "named arguments" object:
  - Override middleware list
  - Use an initial state
  - Enable/disable DevTools Extension
  - Provide additional store enhancers
`}</LeftCodeRightMarkdown>
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;
  return (<MDXContent {...props} />);
};
MDXContentWrapperSlide3.isMDXComponent = true;

function MDXContentWrapperSlide4(props) {
  /* @jsxRuntime classic */
/* @jsx mdx */


















const layoutProps = {
  
};
const MDXLayout = "wrapper"
function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    <h4>{`Immer`}</h4>
    <LeftCodeRightMarkdown leftSource={immer} leftStyle={{
      minWidth: 700
    }} mdxType="LeftCodeRightMarkdown">{`
- An immutable update library from Michel Westrate (author of MobX)
  - Uses ES6 Proxies to let you "mutate" your data, but applies the changes immutably
  - Can drastically simplify your immutable update logic
`}</LeftCodeRightMarkdown>
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;
  return (<MDXContent {...props} />);
};
MDXContentWrapperSlide4.isMDXComponent = true;

function MDXContentWrapperSlide5(props) {
  /* @jsxRuntime classic */
/* @jsx mdx */


















const layoutProps = {
  
};
const MDXLayout = "wrapper"
function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    <h4>{`Redux Toolkit: `}<inlineCode parentName="h4">{`createReducer()`}</inlineCode></h4>
    <LeftCodeRightMarkdown leftSource={createReducer} leftStyle={{
      minWidth: 700
    }} mdxType="LeftCodeRightMarkdown">{`
- Accepts a lookup table of action types to reducer functions
- It uses Immer internally, so your reducers can "mutate" the state!
- **Warning:** this only works _if_ you are using the "magic" \`createReducer\` with Immer inside. Otherwise, these functions \`are\` mutating the state!
`}</LeftCodeRightMarkdown>
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;
  return (<MDXContent {...props} />);
};
MDXContentWrapperSlide5.isMDXComponent = true;

function MDXContentWrapperSlide6(props) {
  /* @jsxRuntime classic */
/* @jsx mdx */


















const layoutProps = {
  
};
const MDXLayout = "wrapper"
function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    <h4>{`Redux Toolkit: `}<inlineCode parentName="h4">{`createAction()`}</inlineCode></h4>
    <LeftCodeRightMarkdown leftSource={createAction} leftStyle={{
      minWidth: 700
    }} mdxType="LeftCodeRightMarkdown">{`
- Inspired by \`redux-actions\`
- Generates an action creator that uses the given type and accepts \`payload\` as an argument
- Action creator function overrides \`toString()\`, so it can be used as the "action type" itself where needed (also exposed as \`actionCreator.type\`)
`}</LeftCodeRightMarkdown>
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;
  return (<MDXContent {...props} />);
};
MDXContentWrapperSlide6.isMDXComponent = true;

function MDXContentWrapperSlide7(props) {
  /* @jsxRuntime classic */
/* @jsx mdx */


















const layoutProps = {
  
};
const MDXLayout = "wrapper"
function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    <h4>{`Redux Toolkit: `}<inlineCode parentName="h4">{`createSlice()`}</inlineCode></h4>
    <LeftCodeRightMarkdown leftSource={createSlice} leftStyle={{
      minWidth: 700
    }} mdxType="LeftCodeRightMarkdown">{`
- Inspired by Eric Elliott's \`autodux\` project
- Accepts an object of reducers, and returns auto-generated action creators, action types, and a reducer function
- Uses our "magic" \`createReducer\` utility, so that your reducers can "mutate" their state
- Makes it easy to use the "ducks" pattern (default export reducer, named export action creators)
`}</LeftCodeRightMarkdown>
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;
  return (<MDXContent {...props} />);
};
MDXContentWrapperSlide7.isMDXComponent = true;

function MDXContentWrapperSlide8(props) {
  /* @jsxRuntime classic */
/* @jsx mdx */


















const layoutProps = {
  
};
const MDXLayout = "wrapper"
function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    <h4>{`Redux Toolkit: `}<inlineCode parentName="h4">{`createSlice()`}</inlineCode></h4>
    <LeftCodeRightMarkdown leftSource={createSlice2} leftStyle={{
      minWidth: 700
    }} mdxType="LeftCodeRightMarkdown">{`
- Usage patterns:
  - Can handle other action types using \`extraReducers\`
  - Slices are just actions + reducers - write side effects like thunks separately and use the generated action creators, same as usual
`}</LeftCodeRightMarkdown>
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;
  return (<MDXContent {...props} />);
};
MDXContentWrapperSlide8.isMDXComponent = true;

function MDXContentWrapperSlide9(props) {
  /* @jsxRuntime classic */
/* @jsx mdx */


















const layoutProps = {
  
};
const MDXLayout = "wrapper"
function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    <h4>{`Redux Toolkit: `}<inlineCode parentName="h4">{`createSelector()`}</inlineCode></h4>
    <LeftCodeRightMarkdown leftSource={createSelector} leftStyle={{
      minWidth: 700
    }} mdxType="LeftCodeRightMarkdown">{`
- Re-exports the \`createSelector\` function from Reselect, for creating memoized selectors
`}</LeftCodeRightMarkdown>
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;
  return (<MDXContent {...props} />);
};
MDXContentWrapperSlide9.isMDXComponent = true;

function MDXContentWrapperSlide10(props) {
  /* @jsxRuntime classic */
/* @jsx mdx */


















const layoutProps = {
  
};
const MDXLayout = "wrapper"
function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    <h4>{`Redux Toolkit: `}<inlineCode parentName="h4">{`createAsyncThunk()`}</inlineCode></h4>
    <LeftCodeRightMarkdown leftSource={createAsyncThunk} leftStyle={{
      minWidth: 700
    }} mdxType="LeftCodeRightMarkdown">{`
- Standard async thunk pattern:
  - Dispatch "loading" action before fetch
  - Dispatch either "success" or "failure" action based on result
- \`createAsyncThunk\` implements that pattern:
  - Accepts an action type string prefix and a "payload creator" callback that returns a Promise
  - Autogenerates actions for \`pending\`, \`fulfilled\`, and \`rejected\` cases
  - Auto dispatches those actions based on promise resolution lifecycle
`}</LeftCodeRightMarkdown>
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;
  return (<MDXContent {...props} />);
};
MDXContentWrapperSlide10.isMDXComponent = true;

function MDXContentWrapperSlide11(props) {
  /* @jsxRuntime classic */
/* @jsx mdx */


















const layoutProps = {
  
};
const MDXLayout = "wrapper"
function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    <h4>{`Redux Toolkit: `}<inlineCode parentName="h4">{`createEntityAdapter()`}</inlineCode></h4>
    <LeftCodeRightMarkdown leftSource={createEntityAdapter} leftStyle={{
      minWidth: 700
    }} mdxType="LeftCodeRightMarkdown">{`
- Redux docs recommend "normalizing" state structure
  - Single copy of each item
  - Track items in an object mapping IDs to items
- \`createEntityAdapter\` implements that pattern:
  - Defines prebuilt reducers for common CRUD logic (add / update / delete, one/many)
  - Reducers can be used directly or as "mutating" helpers
  - Maintains IDs array, with optional sorting based on items
  - Generates basic set of selector functions (select all as array, one by ID, etc)
`}</LeftCodeRightMarkdown>
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;
  return (<MDXContent {...props} />);
};
MDXContentWrapperSlide11.isMDXComponent = true;

function MDXContentWrapperSlide12(props) {
  /* @jsxRuntime classic */
/* @jsx mdx */


















const layoutProps = {
  
};
const MDXLayout = "wrapper"
function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    <h4>{`Redux Toolkit: Safety Checks`}</h4>
    <ul>
      <li parentName="ul">{`Most common mistake with Redux: accidental mutations!`}
        <ul parentName="li">
          <li parentName="ul">{`Can happen in a reducer, `}<em parentName="li">{`or`}</em>{` outside a reducer (`}<inlineCode parentName="li">{`mapState`}</inlineCode>{`, etc)`}</li>
          <li parentName="ul">{`Usually results in connected components not re-rendering, or bad data when debugging`}</li>
          <li parentName="ul"><em parentName="li">{`Really`}</em>{` hard to figure out where this happened... or is it?`}</li>
        </ul>
      </li>
    </ul>
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;
  return (<MDXContent {...props} />);
};
MDXContentWrapperSlide12.isMDXComponent = true;

function MDXContentWrapperSlide13(props) {
  /* @jsxRuntime classic */
/* @jsx mdx */


















const layoutProps = {
  
};
const MDXLayout = "wrapper"
function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    <h4>{`Redux Toolkit: Safety Checks`}</h4>
    <ul>
      <li parentName="ul">{`Most common mistake with Redux: accidental mutations!`}
        <ul parentName="li">
          <li parentName="ul">{`Can happen in a reducer, `}<em parentName="li">{`or`}</em>{` outside a reducer (`}<inlineCode parentName="li">{`mapState`}</inlineCode>{`, etc)`}</li>
          <li parentName="ul">{`Usually results in connected components not re-rendering, or bad data when debugging`}</li>
          <li parentName="ul"><em parentName="li">{`Really`}</em>{` hard to figure out where this happened... or is it?`}</li>
        </ul>
      </li>
      <li parentName="ul">{`Several existing "mutation detection" middleware available - the best one is `}<inlineCode parentName="li">{`redux-immutable-state-invariant`}</inlineCode></li>
      <li parentName="ul">{`Redux Toolkit's `}<inlineCode parentName="li">{`configureStore()`}</inlineCode>{` adds a port of `}<inlineCode parentName="li">{`redux-immutable-state-invariant`}</inlineCode>{` by default!`}
        <ul parentName="li">
          <li parentName="ul">{`Throws an error when accidental mutations are detected`}</li>
          <li parentName="ul">{`Tells you the state path where the mutation occurred`}</li>
        </ul>
      </li>
      <li parentName="ul">{`RTK also adds a check for "non-serializable values" in state and actions by default`}
        <ul parentName="li">
          <li parentName="ul">{`Created by me, modeled on the mutation check middleware`}</li>
        </ul>
      </li>
    </ul>
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;
  return (<MDXContent {...props} />);
};
MDXContentWrapperSlide13.isMDXComponent = true;

function MDXContentWrapperSlide14(props) {
  /* @jsxRuntime classic */
/* @jsx mdx */


















const layoutProps = {
  
};
const MDXLayout = "wrapper"
function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    <h4>{`Redux Toolkit: RTK Query`}</h4>
    <LeftCodeRightMarkdown leftSource={rtkQueryExample} leftStyle={{
      minWidth: 800
    }} mdxType="LeftCodeRightMarkdown">{`
- Current live RTK version: 1.5.1
- New upcoming API: [**RTK Query**](https://deploy-preview-1016--redux-starter-kit-docs.netlify.app/tutorials/rtk-query)
  - Advanced data fetching and caching library built for Redux Toolkit
  - Abstracts the data fetching process completely - just define a set of endpoints, and use the auto-generated hooks in your components to fetch data!
  - Manages caching and loading status for each request automatically
  - UI-agnostic core, with additional React-specific functionality on top
- Can potentially replace most or all of your existing data fetching logic in Redux apps - no more writing thunks or reducers for server state!
- [Currently available in RTK 1.6 beta](https://github.com/reduxjs/redux-toolkit/releases/tag/v1.6.0-beta.0) - final version coming soon!
  - **\`npm i @reduxjs/toolkit@next\`**
`}</LeftCodeRightMarkdown>
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;
  return (<MDXContent {...props} />);
};
MDXContentWrapperSlide14.isMDXComponent = true;

function MDXContentWrapperSlide15(props) {
  /* @jsxRuntime classic */
/* @jsx mdx */


















const layoutProps = {
  
};
const MDXLayout = "wrapper"
function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    <h4>{`Redux Toolkit: RTK Query`}</h4>
    <LeftCodeRightMarkdown leftSource={rtkQueryExample2} leftStyle={{
      minWidth: 800
    }} mdxType="LeftCodeRightMarkdown">{`
- Typically one "API slice" per server, with many endpoints
- Non-normalized cache - responses are stored as-is
  - Writing full deduplicating caches is _hard_ (see: Apollo)
  - Can transform responses however you want, including using RTK's \`createEntityAdapter\` to normalize
- Can select individual values from a response in components
  - List component can \`useMyListQuery()\`
  - List items can use same query, but select specific values
- "Cache query lifecycle" enables streaming updates (initial HTTP request, update cache from websocket messages)
`}</LeftCodeRightMarkdown>
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;
  return (<MDXContent {...props} />);
};
MDXContentWrapperSlide15.isMDXComponent = true;

function MDXContentWrapperSlide16(props) {
  /* @jsxRuntime classic */
/* @jsx mdx */


















const layoutProps = {
  
};
const MDXLayout = "wrapper"
function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    <h4>{`Redux and TypeScript: App Setup`}</h4>
    <LeftCodeRightMarkdown leftSource={tsSetup} leftStyle={{
      minWidth: 850
    }} leftLanguage="typescript" mdxType="LeftCodeRightMarkdown">{`
- Recommended TypeScript setup: 
  - Infer \`RootState\` and \`AppDispatch\` types from the store itself
  - Export these types for use throughout the app
 - Create "pre-typed" React-Redux hooks that use those types
   - Avoids repetition of \`RootState\` in inline selectors
   - Avoids common issue of \`dispatch\` not recognizing thunks as dispatchable values
`}</LeftCodeRightMarkdown>
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;
  return (<MDXContent {...props} />);
};
MDXContentWrapperSlide16.isMDXComponent = true;

function MDXContentWrapperSlide17(props) {
  /* @jsxRuntime classic */
/* @jsx mdx */


















const layoutProps = {
  
};
const MDXLayout = "wrapper"
function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    <h4>{`Redux and TypeScript: App Usage`}</h4>
    <LeftCodeRightMarkdown leftSource={tsUsage} leftStyle={{
      minWidth: 850
    }} leftLanguage="typescript" mdxType="LeftCodeRightMarkdown">{`
- Provide type for initial slice state
- Use \`PayloadAction<T>\` to declare action contents
- Import and use pre-typed hooks in components
`}</LeftCodeRightMarkdown>
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;
  return (<MDXContent {...props} />);
};
MDXContentWrapperSlide17.isMDXComponent = true;

function MDXContentWrapperSlide18(props) {
  /* @jsxRuntime classic */
/* @jsx mdx */


















const layoutProps = {
  
};
const MDXLayout = "wrapper"
function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    <h4>{`Redux Templates for Create-React-App`}</h4>
    <ul>
      <li parentName="ul">{`Two Redux templates available for CRA:`}
        <ul parentName="li">
          <li parentName="ul"><a parentName="li" {...{
              "href": "https://github.com/reduxjs/cra-template-redux"
            }}>{`https://github.com/reduxjs/cra-template-redux`}</a></li>
          <li parentName="ul"><a parentName="li" {...{
              "href": "https://github.com/reduxjs/cra-template-redux-typescript"
            }}>{`https://github.com/reduxjs/cra-template-redux-typescript`}</a>{` `}</li>
        </ul>
      </li>
      <li parentName="ul">{`Both come with RTK and React-Redux hooks as default`}</li>
      <li parentName="ul"><inlineCode parentName="li">{`create-react-app --template redux`}</inlineCode>{` (or `}<inlineCode parentName="li">{`--template redux-typescript`}</inlineCode>{`)`}</li>
    </ul>
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;
  return (<MDXContent {...props} />);
};
MDXContentWrapperSlide18.isMDXComponent = true;

function MDXContentWrapperNotes0(props) {
  /* @jsxRuntime classic */
/* @jsx mdx */


















const layoutProps = {
  
};
const MDXLayout = "wrapper"
function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;
  return (<MDXContent {...props} />);
};
MDXContentWrapperNotes0.isMDXComponent = true;

function MDXContentWrapperNotes1(props) {
  /* @jsxRuntime classic */
/* @jsx mdx */


















const layoutProps = {
  
};
const MDXLayout = "wrapper"
function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;
  return (<MDXContent {...props} />);
};
MDXContentWrapperNotes1.isMDXComponent = true;

function MDXContentWrapperNotes2(props) {
  /* @jsxRuntime classic */
/* @jsx mdx */


















const layoutProps = {
  
};
const MDXLayout = "wrapper"
function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;
  return (<MDXContent {...props} />);
};
MDXContentWrapperNotes2.isMDXComponent = true;

function MDXContentWrapperNotes3(props) {
  /* @jsxRuntime classic */
/* @jsx mdx */


















const layoutProps = {
  
};
const MDXLayout = "wrapper"
function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;
  return (<MDXContent {...props} />);
};
MDXContentWrapperNotes3.isMDXComponent = true;

function MDXContentWrapperNotes4(props) {
  /* @jsxRuntime classic */
/* @jsx mdx */


















const layoutProps = {
  
};
const MDXLayout = "wrapper"
function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;
  return (<MDXContent {...props} />);
};
MDXContentWrapperNotes4.isMDXComponent = true;

function MDXContentWrapperNotes5(props) {
  /* @jsxRuntime classic */
/* @jsx mdx */


















const layoutProps = {
  
};
const MDXLayout = "wrapper"
function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;
  return (<MDXContent {...props} />);
};
MDXContentWrapperNotes5.isMDXComponent = true;

function MDXContentWrapperNotes6(props) {
  /* @jsxRuntime classic */
/* @jsx mdx */


















const layoutProps = {
  
};
const MDXLayout = "wrapper"
function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;
  return (<MDXContent {...props} />);
};
MDXContentWrapperNotes6.isMDXComponent = true;

function MDXContentWrapperNotes7(props) {
  /* @jsxRuntime classic */
/* @jsx mdx */


















const layoutProps = {
  
};
const MDXLayout = "wrapper"
function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;
  return (<MDXContent {...props} />);
};
MDXContentWrapperNotes7.isMDXComponent = true;

function MDXContentWrapperNotes8(props) {
  /* @jsxRuntime classic */
/* @jsx mdx */


















const layoutProps = {
  
};
const MDXLayout = "wrapper"
function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;
  return (<MDXContent {...props} />);
};
MDXContentWrapperNotes8.isMDXComponent = true;

function MDXContentWrapperNotes9(props) {
  /* @jsxRuntime classic */
/* @jsx mdx */


















const layoutProps = {
  
};
const MDXLayout = "wrapper"
function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;
  return (<MDXContent {...props} />);
};
MDXContentWrapperNotes9.isMDXComponent = true;

function MDXContentWrapperNotes10(props) {
  /* @jsxRuntime classic */
/* @jsx mdx */


















const layoutProps = {
  
};
const MDXLayout = "wrapper"
function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;
  return (<MDXContent {...props} />);
};
MDXContentWrapperNotes10.isMDXComponent = true;

function MDXContentWrapperNotes11(props) {
  /* @jsxRuntime classic */
/* @jsx mdx */


















const layoutProps = {
  
};
const MDXLayout = "wrapper"
function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;
  return (<MDXContent {...props} />);
};
MDXContentWrapperNotes11.isMDXComponent = true;

function MDXContentWrapperNotes12(props) {
  /* @jsxRuntime classic */
/* @jsx mdx */


















const layoutProps = {
  
};
const MDXLayout = "wrapper"
function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;
  return (<MDXContent {...props} />);
};
MDXContentWrapperNotes12.isMDXComponent = true;

function MDXContentWrapperNotes13(props) {
  /* @jsxRuntime classic */
/* @jsx mdx */


















const layoutProps = {
  
};
const MDXLayout = "wrapper"
function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;
  return (<MDXContent {...props} />);
};
MDXContentWrapperNotes13.isMDXComponent = true;

function MDXContentWrapperNotes14(props) {
  /* @jsxRuntime classic */
/* @jsx mdx */


















const layoutProps = {
  
};
const MDXLayout = "wrapper"
function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;
  return (<MDXContent {...props} />);
};
MDXContentWrapperNotes14.isMDXComponent = true;

function MDXContentWrapperNotes15(props) {
  /* @jsxRuntime classic */
/* @jsx mdx */


















const layoutProps = {
  
};
const MDXLayout = "wrapper"
function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;
  return (<MDXContent {...props} />);
};
MDXContentWrapperNotes15.isMDXComponent = true;

function MDXContentWrapperNotes16(props) {
  /* @jsxRuntime classic */
/* @jsx mdx */


















const layoutProps = {
  
};
const MDXLayout = "wrapper"
function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;
  return (<MDXContent {...props} />);
};
MDXContentWrapperNotes16.isMDXComponent = true;

function MDXContentWrapperNotes17(props) {
  /* @jsxRuntime classic */
/* @jsx mdx */


















const layoutProps = {
  
};
const MDXLayout = "wrapper"
function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;
  return (<MDXContent {...props} />);
};
MDXContentWrapperNotes17.isMDXComponent = true;

function MDXContentWrapperNotes18(props) {
  /* @jsxRuntime classic */
/* @jsx mdx */


















const layoutProps = {
  
};
const MDXLayout = "wrapper"
function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;
  return (<MDXContent {...props} />);
};
MDXContentWrapperNotes18.isMDXComponent = true;


export const notes = [MDXContentWrapperNotes0,MDXContentWrapperNotes1,MDXContentWrapperNotes2,MDXContentWrapperNotes3,MDXContentWrapperNotes4,MDXContentWrapperNotes5,MDXContentWrapperNotes6,MDXContentWrapperNotes7,MDXContentWrapperNotes8,MDXContentWrapperNotes9,MDXContentWrapperNotes10,MDXContentWrapperNotes11,MDXContentWrapperNotes12,MDXContentWrapperNotes13,MDXContentWrapperNotes14,MDXContentWrapperNotes15,MDXContentWrapperNotes16,MDXContentWrapperNotes17,MDXContentWrapperNotes18];


export default [MDXContentWrapperSlide0,MDXContentWrapperSlide1,MDXContentWrapperSlide2,MDXContentWrapperSlide3,MDXContentWrapperSlide4,MDXContentWrapperSlide5,MDXContentWrapperSlide6,MDXContentWrapperSlide7,MDXContentWrapperSlide8,MDXContentWrapperSlide9,MDXContentWrapperSlide10,MDXContentWrapperSlide11,MDXContentWrapperSlide12,MDXContentWrapperSlide13,MDXContentWrapperSlide14,MDXContentWrapperSlide15,MDXContentWrapperSlide16,MDXContentWrapperSlide17,MDXContentWrapperSlide18]